import { combineReducers } from "redux"

import { shellReducer } from "@containers/App/reducer"
import { footerReducer } from "@containers/Footer/reducer"
import { searchReducer } from "@containers/Search/reducer"
import { locationsReducer } from "@containers/LocationPicker/reducer"
import { savingsPageReducer } from "@pages/SavingsPage/reducer"
import { abExperimentReducer } from "@containers/App/ABExperimentReducer/reducer"

/**
 * @description A 'Reducer Manager' object, which keeps track of all the registered reducers and exposes a reduce() function. For detailed info :- https://redux.js.org/usage/code-splitting#using-a-reducer-manager
 */

export function createReducerManager() {
    // Create an object which maps keys to reducers
    const reducers = {
        footerReducer,
        searchReducer,
        locationsReducer,
        savingsPageReducer,
        shellReducer,
        abExperimentReducer,
    }

    // Create the initial combinedReducer
    let reducerObj = combineReducers(reducers)

    // An array which is used to delete state keys when reducers are removed
    let keysToRemove = []

    return {
        getReducerMap: () => combineReducers(reducers),

        // This will be passed to the store
        reduce: (state, action) => {
            // If any reducers have been removed, clean up their state first
            if (keysToRemove.length > 0) {
                state = { ...state }
                for (let key of keysToRemove) {
                    delete state[key]
                }
                keysToRemove = []
            }

            // Delegate to the combined reducer
            return reducerObj(state, action)
        },

        // Adds a new reducer with the specified key
        add: (reducer) => {
            for (let key in reducer) {
                if (!key) {
                    return
                }

                // We will skip a step if the reducer is already present
                if (reducers[key]) {
                    continue
                }

                // Add the reducer to the reducer mapping
                reducers[key] = reducer[key]
            }

            // Generate a new combined reducer
            return combineReducers(reducers)
        },

        // Removes a reducer with the specified key
        remove: (key) => {
            if (!key || !reducers[key]) {
                return
            }

            // Remove it from the reducer mapping
            delete reducers[key]

            // Add the key to the list of keys to clean up
            keysToRemove.push(key)

            // Generate a new combined reducer
            return combineReducers(reducers)
        },
    }
}
